import loadPage from '../pages.js';
import lazyLoad from '../includes/lazy-load.js';

async function initChart() {
	switch(window.section) {
		case 'seasonality':
		case 'sentiment':
		case 'economy':
		case 'charts':
		case 'stock-score':
		case 'fundamentals':
		case 'financials':
		case 'ai-charts':
			const sectionDiv = $(`.section-${window.section}`);

			await loadPage(window.section, window.pageData, sectionDiv);
		break;
	}
};

function loadChart() {
	const data = {
		section: window.section,
		symbol: window.symbol,
		settings: window.chartSettings,
		ident: window.ident,
	}

	ajax('standaloneChart', data, function(res) {
		window.pageData = res.pageData;
		$('#chart-div-placeholder').replaceWith(res.html);

		initChart();
	});
}

export default async function() {
	if (window.isWidget) {
		lazyLoad(
			[ ... document.getElementsByClassName(`financhill-chart`) ],
			window.isLazyLoad ? loadChart : initChart
		);
	} else {
		await initChart();
	}
}
